import { useState } from "react";
import Product from "./Product";
import Pagination from "../pagination/Pagination";
import useAuth from "../../hooks/useAuth";
import Rolling from "../loading/Rolling";
import rolling from "../../assets/rolling.svg";

const Products = () => {
  const { seller } = useAuth();
  const { sellers, loading } = seller;

  const [value, setValue] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(5);
  const lastItem = currentPage * itemPerPage;
  const firstItem = lastItem - itemPerPage;
  const currentItem = sellers.slice(firstItem, lastItem);

  return (
    <>
      {loading ? (
        <Rolling src={rolling} />
      ) : (
        <div>
          <Product products={currentItem} />
          <Pagination
            itemPerPage={itemPerPage}
            totalItem={sellers.length}
            value={value}
            setValue={setValue}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      )}
    </>
  );
};

export default Products